var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line, _line2, _line3, _line4, _line5, _line6, _path11, _ellipse, _g, _path12, _path13, _g2, _path14, _path15, _path16, _g3, _path17, _g4, _path18, _path19, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 160,
    viewBox: "0 0 280 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1157_63132)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 160,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    width: 280,
    height: 160,
    fill: "#B3EBDA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: -0.0883789,
    y: 106.667,
    width: 280,
    height: 53.3333,
    fill: "#66D7B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.61 106.447C201.608 106.463 201.61 106.402 201.61 106.447L202.856 106.447C202.856 106.56 202.865 106.409 202.856 106.447C202.842 106.506 202.878 106.375 202.856 106.447C202.813 106.591 202.87 106.409 202.793 106.637C202.637 107.095 202.408 107.735 202.116 108.533C201.532 110.131 200.686 112.383 199.64 115.134C197.549 120.637 194.653 128.148 191.436 136.444C185.002 153.037 177.281 172.778 172.135 185.894L171.084 185.356C176.231 172.241 183.951 152.502 190.384 135.911C193.6 127.616 196.495 120.108 198.585 114.61C199.63 111.86 200.473 109.615 201.054 108.026C201.345 107.23 201.46 106.889 201.61 106.447C201.628 106.387 201.605 106.47 201.61 106.447Z",
    fill: "#66D7B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.658 187.106L175.881 106.22L176.928 106.765L144.705 187.651L143.658 187.106Z",
    fill: "#66D7B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.334 186.43C134.849 159.818 158.009 106.252 158.616 104.691L159.668 105.225C159.048 106.819 135.868 160.431 124.366 187.013L123.334 186.43Z",
    fill: "#66D7B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.886 109.167C133.097 108.546 133.185 108.175 133.196 108.008L134.344 108.113C134.317 108.494 134.167 109.031 133.958 109.644C133.742 110.281 133.435 111.075 133.051 112.006C132.282 113.869 131.189 116.308 129.851 119.179C127.173 124.924 123.499 132.424 119.434 140.555C111.302 156.818 101.594 175.619 95.1358 187.969L94.1479 187.295C100.604 174.948 110.307 156.155 118.434 139.903C122.498 131.776 126.165 124.288 128.835 118.561C130.17 115.696 131.253 113.279 132.01 111.445C132.389 110.527 132.683 109.763 132.886 109.167Z",
    fill: "#66D7B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1934 181.76L85.9411 106.353H87.3894L44.1583 182.476L43.1934 181.76ZM64.2956 185.48C77.0856 163.554 108.219 108.802 109.596 106.353H110.723C109.338 108.814 78.037 164.294 65.2531 186.209L64.2956 185.48Z",
    fill: "#66D7B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8374 187.89L60.0513 106.537H61.4995L19.8322 188.551L18.8374 187.89Z",
    fill: "#66D7B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3925 124.383C24.7871 119.671 30.4609 107.047 30.9065 106.353H32.1939C31.7956 106.974 25.8066 120.284 23.3877 125.044C20.9819 129.778 17.8227 136.064 14.388 142.932C7.51882 156.668 -0.450195 172.724 -5.6926 183.318L-6.69434 182.671C-1.45143 172.075 6.51851 156.018 13.3889 142.28C16.824 135.411 19.9848 129.121 22.3925 124.383Z",
    fill: "#66D7B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.361 106.492C266.431 106.492 266.791 106.492 266.361 106.492L267.512 106.492C267.402 106.492 267.486 106.551 267.512 106.492C266.426 108.942 265.587 111.287 264.101 115.036C261.128 122.533 257.48 132.256 253.633 142.772C245.939 163.803 237.453 187.988 231.988 203.841L230.917 203.359C236.384 187.501 244.873 163.307 252.571 142.265C256.42 131.745 260.073 122.008 263.052 114.493C264.542 110.736 265.264 108.966 266.361 106.492ZM265.237 210.854L294.172 106.492L295.323 106.492L266.334 211.252L265.237 210.854Z",
    fill: "#66D7B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.104 112.6L233.519 106.537L234.567 107.082L232.371 112.594L299.83 112.289L299.834 113.605L231.846 113.912L224.887 131.378C260.409 131.441 288.635 131.26 302.689 130.703L302.729 132.017C288.594 132.578 260.145 132.757 224.364 132.692L218.132 148.335C270.138 148.332 306.992 148.305 308.829 148.239L308.865 149.554C307.012 149.62 269.903 149.647 217.608 149.651L203.303 185.557L202.255 185.012L216.343 149.651C129.719 149.656 2.24979 149.6 -76.105 149.554L-76.1044 148.239C2.42519 148.284 130.248 148.341 216.867 148.335L223.1 132.69C135.707 132.517 5.4773 130.909 -67.2892 129.826L-67.2742 128.511C5.65421 129.596 136.251 131.209 223.624 131.376L230.579 113.917L-40.0432 115.139L-40.0477 113.824L231.104 112.6Z",
    fill: "#66D7B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.112 0H117.902L71.2889 119.462C70.4991 120.672 70.0059 121.917 69.8349 123.189L69.4419 124.196L69.7673 124.196C69.7673 136.774 101.265 146.971 140.119 146.971C178.973 146.971 210.47 136.774 210.47 124.196C210.47 122.351 209.793 120.558 208.514 118.841L165.112 0Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 179.193,
    y1: 33.8797,
    x2: 189.682,
    y2: 11.63,
    stroke: "#06AB78",
    strokeWidth: 0.882353
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 194.681,
    y1: 42.5602,
    x2: 226.148,
    y2: 29.5282,
    stroke: "#06AB78",
    strokeWidth: 0.882353
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 192.261,
    y1: 60.0109,
    x2: 208.471,
    y2: 58.3226,
    stroke: "#06AB78",
    strokeWidth: 0.882353
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 77.2773,
    y1: 30.9089,
    x2: 65.1989,
    y2: 20.7375,
    stroke: "#06AB78",
    strokeWidth: 0.882353
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 66.902,
    y1: 43.3748,
    x2: 35.7523,
    y2: 30.3428,
    stroke: "#06AB78",
    strokeWidth: 0.882353
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 67.0797,
    y1: 60.5729,
    x2: 47.6908,
    y2: 60.9016,
    stroke: "#06AB78",
    strokeWidth: 0.882353
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.411 36.7768C134.176 38.4238 132.764 38.7062 130.835 38.2356C130.349 39.0199 129.084 40.8709 127.917 42.0003C126.801 43.0803 125.63 42.0947 125.5 41.0873C125.445 40.6691 125.215 40.0544 124.928 39.7453C124.505 39.2892 124.291 38.5858 124.926 38.0002C125.234 37.7151 125.366 37.1544 125.242 36.7532C125.004 35.9885 125.166 35.0165 126.447 34.9508C126.797 34.9328 127.104 34.6588 127.221 34.3282C127.623 33.191 129.107 32.55 130.224 33.4081C130.434 33.5689 130.716 33.6219 130.962 33.5261C132.175 33.0535 132.727 33.7517 132.92 34.4167C132.992 34.6646 133.182 34.8724 133.418 34.9758C133.952 35.2092 134.558 35.7501 134.411 36.7768Z",
    fill: "#06AB78"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1157_63132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 34,
    width: 8,
    height: 11
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.158,
    cy: 39.3472,
    rx: 3.29412,
    ry: 4.89412,
    transform: "rotate(-7.28534 130.158 39.3472)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1157_63132)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.158,
    cy: 39.3472,
    rx: 3.29412,
    ry: 4.89412,
    transform: "rotate(-7.28534 130.158 39.3472)",
    fill: "#66D7B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.729 39.271C127.682 40.1651 127.07 40.5886 126.317 40.4945V33.9063L131.258 32.6827C132.482 33.8278 134.665 36.3722 133.611 37.3886C132.293 38.6592 131.305 36.4945 130.646 37.2004C129.987 37.9063 129.517 37.7651 128.576 37.5298C128.905 39.2239 127.776 38.3769 127.729 39.271Z",
    fill: "#06AB78"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.788 41.5175C129.862 42.1635 130.935 42.6139 131.506 42.1897",
    stroke: "#06AB78",
    strokeWidth: 0.597573
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1157_63132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 6,
    width: 58,
    height: 60
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.871 65.0755H123.123C122.479 62.6122 122.23 61.0251 122.225 57.3831L105.079 23.812C103.861 22.4955 101.519 19.5175 100.712 18.1394C99.7038 16.4167 101.553 15.8705 102.687 17.3831C101.637 15.5763 102.225 14.1058 104.284 16.1226C103.401 14.3579 104.746 12.7612 106.09 14.652C107.166 16.1646 108.247 17.4391 108.653 17.8873C108.891 17.131 109.586 15.61 110.46 15.5763C111.334 15.5427 111.104 19.1478 110.88 20.9545L125.796 48.8116L136.426 47.9293L148.695 15.5763C148.247 14.1478 147.46 11.0301 147.897 9.98811C148.334 8.94609 149.424 10.4223 149.914 11.2906C150.11 10.3803 150.603 8.27382 151.006 7.13096C151.51 5.70239 152.855 6.29063 152.771 8.05534C153.905 6.03853 155.334 6.37466 155.166 8.4755C156.216 6.4587 157.561 7.50912 157.183 9.39987C156.88 10.9125 146.749 40.7304 141.721 55.4503C142.249 58.3237 143.219 64.2714 142.871 65.0755Z",
    fill: "#01B388"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1157_63132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.165 44.3583L137.98 38.8961L146.425 15.9552L162.938 19.6947L150.165 44.3583Z",
    fill: "#66D7B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.868 65.0756H123.12C122.477 62.6124 122.227 61.0252 122.222 57.3832L105.079 23.8122L110.877 20.9547L125.793 48.8118L136.424 47.9295L148.135 17.0475L154.277 18.371C150.825 28.7179 145.11 45.5199 141.718 55.4505C142.246 58.3238 143.216 64.2716 142.868 65.0756Z",
    fill: "#66D7B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.249 47.7613L123.358 42.089L124.913 45.9966H133.232C133.501 45.9966 135.893 41.4027 137.644 38.5176L149.199 44.652C149.661 52.3691 150.61 65.7529 150.711 65.9546C150.837 66.2067 121.173 66.8789 120.837 66.8789C120.568 66.8789 117.35 54.4419 115.249 47.7613Z",
    fill: "#06AB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.98 47.9295C128.335 48.798 129.043 50.1534 129.936 51.1648M135.711 47.3832C135.502 48.396 134.997 50.017 134.215 51.1648M129.936 51.1648L130.711 47.6353M129.936 51.1648C130.499 51.8019 131.135 52.3025 131.804 52.4586M131.804 52.4586C131.956 52.4943 132.11 52.512 132.266 52.5093C133.037 52.4958 133.688 51.9375 134.215 51.1648M131.804 52.4586L132.266 47.9295M134.215 51.1648L133.316 47.6353M116.215 46.795L122.77 42.2152M139.072 39.1479L147.392 43.3076M137.602 55.2824C134.28 58.6827 132.028 59.8805 127.392 60.8706",
    stroke: "#B3EBDA",
    strokeWidth: 0.588235
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152.767 23.1822L146.539 21.2423C146.657 20.6332 147.009 19.3913 147.087 18.9773C147.184 18.4599 147.044 17.3691 146.875 15.9828C146.705 14.5964 146.779 11.782 147.719 11.6274C148.471 11.5038 149.059 13.8612 149.26 15.0554C150.145 13.1744 152.103 9.50101 152.856 9.85511C153.608 10.2092 152.847 12.9218 152.372 14.2338C153.055 12.9108 154.553 10.3409 155.086 10.6455C155.618 10.9501 155.049 13.3466 154.699 14.5068C155.162 13.8727 156.185 12.6607 156.566 12.8851C157.042 13.1655 156.34 15.0877 155.744 16.2826C155.267 17.2385 153.56 21.2806 152.767 23.1822Z",
    fill: "#66D7B4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.632 18.1387C152.072 18.1914 151.226 18.2709 150.402 19.5694",
    stroke: "#06AB78",
    strokeWidth: 0.588235,
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1157_63132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 11,
    width: 12,
    height: 14
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.365 24.4081L111.14 21.3746C110.671 20.3855 110.38 19.3657 110.486 18.1053C110.24 14.0169 110.076 15.635 107.346 15.7812C106.135 14.0912 103.545 10.8323 102.869 11.3166C102.193 11.8009 103.432 14.3311 104.136 15.5357C103.226 14.3579 101.287 12.1011 100.819 12.497C100.35 12.8928 101.902 15.8035 102.457 16.8812C102.109 17.9245 101.232 18.5795 102.76 20.6124C103.402 21.4663 104.241 22.6812 105.365 24.4081Z",
    fill: "#B3EBDA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1157_63132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.365 24.4081L111.14 21.3746C110.671 20.3855 110.38 19.3657 110.486 18.1053C110.24 14.0169 110.076 15.635 107.346 15.7812C106.135 14.0912 103.545 10.8323 102.869 11.3166C102.193 11.8009 103.432 14.3311 104.136 15.5357C103.226 14.3579 101.287 12.1011 100.819 12.497C100.35 12.8928 101.902 15.8035 102.457 16.8812C102.109 17.9245 101.232 18.5795 102.76 20.6124C103.402 21.4663 104.241 22.6812 105.365 24.4081Z",
    fill: "#66D7B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.913 14.9184C107.84 15.0869 106.55 16.7705 106.113 18.2695C105.958 18.892 106.318 19.9683 108.11 18.4036",
    stroke: "#06AB78",
    strokeWidth: 0.588235,
    strokeLinejoin: "bevel"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1157_63132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 64,
    width: 46,
    height: 69
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142.183 64.9026H122.435C120.993 67.0735 118.595 73.348 120.544 81.0791C122.981 90.7429 118.317 120.491 124.746 128.054H140.418C140.054 127.256 139.225 124.55 138.822 120.113C138.418 115.676 136.133 82.9278 136.133 82.9278C136.133 82.9278 140.375 117.861 150.754 131.144C155.334 137.006 164.785 126.919 164.575 120.113C164.575 116.793 159.281 109.695 156.193 102.048C153.104 94.4005 148.563 78.8564 146.192 74.2535C143.822 69.6505 142.645 65.855 142.183 64.9026Z",
    fill: "#EAEBF0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1157_63132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.183 64.9026H122.435C120.993 67.0735 118.595 73.348 120.544 81.0791C122.981 90.7429 118.317 120.491 124.746 128.054H140.418C140.054 127.256 139.225 124.55 138.822 120.113C138.418 115.676 136.133 82.9278 136.133 82.9278C136.133 82.9278 140.375 117.861 150.754 131.144C150.754 131.144 164.785 126.919 164.575 120.113C164.575 116.793 159.281 109.695 156.193 102.048C153.104 94.4005 148.563 78.8564 146.192 74.2535C143.822 69.6505 142.645 65.855 142.183 64.9026Z",
    fill: "#66D7B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.852 125.729C161.289 127.98 157.23 129.72 155.718 130.224C154.115 130.759 146.828 131.443 148.692 127.342C150.261 123.889 159.038 117.971 161.633 122.194C162.63 123.817 162.188 124.384 161.852 125.729Z",
    fill: "#06AB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.354 67.1847L138.336 66.9145L138.066 66.9095L135.214 66.8561L134.904 66.8503L134.914 67.1601L135.218 76.1311L135.234 76.5884L135.643 76.3844C136.012 76.2006 136.752 75.7717 137.4 75.1168C138.047 74.4626 138.63 73.5537 138.611 72.4188C138.591 71.1512 138.473 69.0486 138.354 67.1847Z",
    stroke: "#06AB78",
    strokeWidth: 0.588235
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1157_63132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 121,
    width: 53,
    height: 16
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M159.155 136.163H155.625L151.339 129.062L151.76 127.172L157.726 121.499C157.978 121.751 158.751 122.625 159.827 124.104C161.171 125.953 166.76 129.104 169.533 131.331C171.751 133.113 172.474 135.295 172.558 136.163H161.928L157.726 131.583L159.155 136.163Z",
    fill: "#9799A3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.753 136.163L134.703 126.877L127.518 127.172C126.439 128.18 123.879 130.55 122.266 131.961C120.652 133.373 120.277 135.351 120.291 136.163H130.585L132.056 132.76L132.77 136.163H135.753Z",
    fill: "#9799A3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1157_63132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.155 136.163H155.625L151.339 129.062L151.76 127.172L157.726 121.499C157.978 121.751 158.751 122.625 159.827 124.104C161.171 125.953 166.76 129.104 169.533 131.331C171.751 133.113 172.474 135.295 172.558 136.163H161.928L157.726 131.583L159.155 136.163Z",
    fill: "#06AB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.753 136.163L134.703 126.877L127.518 127.172C126.439 128.18 123.879 130.55 122.266 131.961C120.652 133.373 120.277 135.351 120.291 136.163H130.585L132.056 132.76L132.77 136.163H135.753Z",
    fill: "#06AB78"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.936 132.676H153.02V132.087H157.936V132.676ZM135.753 133.348H132.056V132.76H135.753V133.348ZM158.861 134.062H153.818V133.474H158.861V134.062ZM136.048 134.398H132.056V133.81H136.048V134.398ZM131.552 135.239H119.955V134.65H131.552V135.239ZM173.104 135.239H160.163V134.65H173.104V135.239ZM136.048 135.407H132.308V134.818H136.048V135.407ZM154.323 134.818H159.071V135.407H154.323V134.818Z",
    fill: "#66D7B4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1157_63132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 160,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.fa123d4edca965fbecf76ecf7c5ed107.svg";
export { ForwardRef as ReactComponent };